import {
  MonthlyCalendar,
  WeeklyCalendar,
  DailyCalendar,
} from '@app/components/Calendars';
import { TaskListRegistry } from '@app/pages/TasksList/components';
import { useTaskListContext } from '@app/providers/TaskListProvider';

export const useTaskListPage = () => {
  const { activeTab } = useTaskListContext();

  const getTabComponent = () => {
    switch (activeTab) {
      case 'registry':
        return TaskListRegistry;
      case 'day':
        return DailyCalendar;
      case 'week':
        return WeeklyCalendar;
      case 'month':
        return MonthlyCalendar;
      default:
        return TaskListRegistry;
    }
  };

  const TabComponent = getTabComponent();

  return { activeTab, TabComponent };
};
